import React, { useState } from 'react';

/**
 * @param {{
 *   buttons: string[],
 *   buttonsType: 'multi' | 'choice' | null,
 *   onSubmit: (text: string) => void
 * }} props
 */
export default function TivButtons({ buttons, buttonsType, onSubmit }) {
  const [selected, setSelected] = useState([]);

  function toggle(btn) {
    setSelected(prev =>
      prev.includes(btn) ? prev.filter(b => b !== btn) : [...prev, btn]
    );
  }

  if (buttonsType === 'multi') {
    return (
      <div className="flex flex-col gap-2.5">
        <div className="flex flex-wrap gap-2">
          {buttons.map(btn => (
            <button
              key={btn}
              onClick={() => toggle(btn)}
              className={`px-3 py-1.5 rounded-xl text-sm border transition-colors ${
                selected.includes(btn)
                  ? 'bg-blue-600/30 border-blue-500/40 text-blue-300'
                  : 'bg-white/[0.04] border-white/[0.08] text-zinc-400 hover:bg-white/[0.07]'
              }`}
            >
              {btn}
            </button>
          ))}
        </div>
        <button
          onClick={() => onSubmit(selected.join(', '))}
          disabled={selected.length === 0}
          className="self-start px-4 py-2 bg-blue-600 hover:bg-blue-500 disabled:opacity-40 disabled:cursor-not-allowed rounded-xl text-sm font-semibold text-white transition-colors"
        >
          Valider
        </button>
      </div>
    );
  }

  // Choix unique : clic direct
  return (
    <div className="flex flex-wrap gap-2">
      {buttons.map(btn => (
        <button
          key={btn}
          onClick={() => onSubmit(btn)}
          className="px-3 py-1.5 rounded-xl text-sm border bg-white/[0.04] border-white/[0.08] text-zinc-400 hover:bg-white/[0.07] transition-colors"
        >
          {btn}
        </button>
      ))}
    </div>
  );
}
